import {showErrorNotification} from "../global/notifications";
import {closeKendoWindow} from "../global/kendoWindows";

const _company = $('#Company').val();
const _contract = $('#Contract').val();

export const approveGridInit = (element) => {
    let $approveGrid = $(element);

    $approveGrid.kendoGrid({
        /*mobile: "phone",*/
        resizable: true, columns: [
            {
                field: 'Approve', title: 'Selected', attributes: {class: ''}, type: 'boolean',
                template: function (dataItem) {
                    return `<div style="text-align: center;"><span class="k-icon k-icon-md ${dataItem.Approve ? 'k-i-check-outline --green' : 'k-i-close-outline --red-dark'}"></span></div>`
                },
                width: 80
            }, {
                field: 'Status', title: 'PCO Status', attributes: {class: ''}, type: 'string'
            }, {
                field: 'PcoDate',
                title: 'PCO Date',
                attributes: {class: ''},
                type: 'date',
                format: '{0: M/d/yyyy}'
            }, {
                field: 'Id', title: 'PCO', attributes: {class: ''}, template: function (dataItem) {
                    return `<div>${dataItem.Id} - ${dataItem.Description}</div>`;
                }
            }, {
                field: 'Amount',
                title: 'Amount',
                attributes: {class: ''},
                type: 'number',
                format: '{0:n2}'
            }, {
                field: 'GpPercent',
                title: 'GP %',
                attributes: {class: ''},
                type: 'number',
                template: function (dataItem) {
                    return `<div data-gp-percent="${dataItem.GpPercent}" data-gp-percent-diff="${dataItem.GpPercentDiff}">${kendo.format('{0:P2}', dataItem.GpPercent / 100)}</div>`;
                }
            }, {
                field: 'NextApprovalRoleTitle',
                title: 'Approving As',
                attributes: {class: ''},
                type: 'string',
            }
        ], dataSource: {
            autoSync: true, schema: {
                model: {
                    id: 'aid', fields: {
                        Approve: {editable: false, type: 'boolean'},
                        PcoDate: {editable: false, type: 'date'},
                        Status: {editable: false, type: 'string'},
                        Id: {editable: false, type: 'string'},
                        Amount: {editable: false, type: 'number'},
                        GpPercent: {editable: false, type: 'number'},
                        ProjectGpPercent: {editable: false, type: 'number'},
                        GpPercentDiff: {editable: false, type: 'number'},
                        NextApprovalRoleTitle: {editable: false, type: 'string'}
                    }
                }
            }, transport: {
                read: {
                    url: '/Operations/PcoApproval/GetApprovalPcoDetailInfo',
                    type: 'GET',
                    dataType: 'json'
                }, parameterMap: function (data, type) {
                    let rs = {};
                    if (type === 'read') {
                        rs['company'] = $('#Company').val();
                        rs['contract'] = $('#Contract').val();
                        return rs;
                    }
                }
            }
        }, dataBound: function (arg) {
            const $grid = arg.sender;
            const $element = $grid.element;
            const $rows = $element.find('tbody [role="row"]');

            $rows.css('cursor', 'pointer');

            $rows.on('click', function () {
                const $self = $(this);
                const $selected = $self.find('.k-icon.k-icon-md');
                const data = $approveGrid.data('kendoGrid').dataSource.data().find(function (element) {
                    return element.uid === $self.data('uid')
                });
                data.Approve = !data.Approve;
                if ($selected.hasClass('--green')) {
                    $selected.removeClass('k-i-check-outline --green').addClass('k-i-close-outline --red-dark');
                } else {
                    $selected.removeClass('k-i-close-outline --red-dark').addClass('k-i-check-outline --green');
                }
            })

            //Set Total
            getGridTotal($approveGrid.data('kendoGrid'));
            setGpPercentBackGround($approveGrid);

            toggleAfterGrid($approveGrid);
        }, mobile: true, scrollable: true, sortable: {
            mode: 'multiple'
        }, filterable: false, editable: false, columnMenu: false,
        filter: function (e) {

        },
        noRecords: {
            template: "There are no items that require your approval at this time"
        }
    })
}
export const approveButtonEvent = ($self) => {
    $('.js-approve-pco').on('click', function () {
        const $pin = $('#pin');
        const pin = $pin.val();
        const $this = $(this);
        $this.hide();

        $pin.removeClass('k-invalid');

        if (pin === '') {
            $pin.addClass('k-invalid');
            showErrorNotification('Please enter your pin');
            $this.show();
            return;
        }

        const pcoList = $('.js-pco-approval-grid').data('kendoGrid').dataSource.data().filter(function (element) {
            return element.Approve
        });
        if (pcoList.length === 0) {
            showErrorNotification('No items have been selected');
            $this.show();
            return;
        }

        let pcoListClone = clonePcoList(pcoList);

        const data = {
            pcoList: pcoListClone,
            pin: pin,
            comments: $('[name="Comments"]').val()
        };

        if (data.comments === '' && GpPercentShowing($self)) {
            showErrorNotification('Comment is required');
            $this.show();
            return;
        }

        approvePcoList(data)
            .then(_ => $('#pcoDetailGrid').data('kendoGrid').dataSource.read())
            .then(_ => closeKendoWindow($self))
            .then(_ => saveFullyApprovedStatus())
            .catch(error => {
                showErrorNotification(error);
                $this.show();
            });
    })
}
const approvePcoList = (data) => {
    return new Promise((resolve, reject) => {
        $.post('/Operations/PcoApproval/ApprovePcoList', data, function (response) {
            if (response.success) {
                resolve();
            } else {
                reject(response.message);
            }
        })
    })
}
const saveFullyApprovedStatus = () => {
    return new Promise((resolve, reject) => {
        $.post('/Operations/PcoApproval/SaveFullyApprovedStatus', {
            company: _company,
            contract: _contract
        }, function (response) {
            if (response.success) {
                resolve();
            } else {
                reject(response.message);
            }
        })
    })
}
export const commentButtonEvent = ($self) => {
    $('.js-request').on('click', function () {
        const pcoList = $('.js-pco-comment-grid').data('kendoGrid').dataSource.data().filter(function (element) {
            return element.Approve
        });

        if (pcoList.length === 0) {
            showErrorNotification('No items have been selected');
            return;
        }

        let notificationList = [];
        $.each($self.find('input[type="checkbox"]'), function (index, ele) {
            const $ele = $(ele);
            if ($ele.prop('checked')) {
                let emails = $ele.val().split(';')
                notificationList = notificationList.concat(emails);
            }
        });

        const data = {
            pcoList: clonePcoList(pcoList),
            notificationList: notificationList,
            comments: $('[name="Comments"]').val().trim()
        };

        if (data.comments === '') {
            showErrorNotification('No Comments were entered');
            return;
        }

        sendComment(data)
            .then(_ => $('#pcoDetailGrid').data('kendoGrid').dataSource.read())
            .then(_ => closeKendoWindow($self))
            .catch(error => showErrorNotification(error));
    })
}

export const commentHistoryEvent = ($self) => {
    $('.js-save-comments').on('click', function () {
        const data = {
            pcoList: [{
                Company: $('[name="Company"]').val(),
                Contract: $('[name="Contract"]').val(),
                Id: $('[name="Pco"]').val()
            }],
            comments: $('[name="Comments"]').val(),
            sendEmail: false
        };

        sendComment(data)
            .then(_ => $('#pcoDetailGrid').data('kendoGrid').dataSource.read())
            .then(_ => closeKendoWindow($self))
            .catch(error => showErrorNotification(error));
    });
}
const sendComment = (data) => {
    return new Promise((resolve, reject) => {
        $.post('/Operations/PcoApproval/SavePcoComment', data, function (response) {
            if (response.success) {
                resolve(response.message);
            } else {
                reject(response.message);
            }
        })
    })
}
const clonePcoList = (pcoList) => {
    let pcoListClone = [];
    let i = pcoList.length;
    let contractDescription = $('#ContractDescription').val()
    while (--i >= 0) {
        pcoListClone.push({
            Amount: pcoList[i].Amount,
            Cost: pcoList[i].Cost,
            Approve: true,
            Company: pcoList[i].Company,
            Contract: pcoList[i].Contract,
            ContractDescription: contractDescription,
            Description: pcoList[i].Description,
            GpPercent: pcoList[i].GpPercent,
            Id: pcoList[i].Id,
            PcoDate: pcoList[i].PcoDate,
            Status: pcoList[i].Status,
        });
    }

    return pcoListClone;
}
const getGridTotal = (k_grid) => {
    const data = k_grid.dataSource.data();
    let total = 0;
    let i = data.length;
    if (i > 0) {
        while (--i >= 0) {
            total += Number(data[i].Amount);
        }
        $('.js-grid-total').text(kendo.toString(total, 'c2'));
    }
}
const toggleAfterGrid = ($grid) => {
    if ($grid.data('kendoGrid').dataSource.data().length > 0) {
        $('.js-after-grid').show();
    } else {
        $('.js-after-grid').hide();
    }
}
const GpPercentShowing = ($self) => {
    return $self.find('.k-grid').data('kendoGrid').dataSource.data().find(ele => {
        return ele.Approve && Math.abs(ele.GpPercentDiff) > 3
    });
}

const setGpPercentBackGround = ($self) => {
    const $gpPercents = $self.find('td[data-field="GpPercent"]');
    let gpError = false;

    $.each($gpPercents, function (index, ele) {
        const $amount = $(ele).find('[data-gp-percent]');
        if ($amount.length && Math.abs($amount.data('gp-percent-diff')) > 3) {
            $(ele).addClass('bg-danger-light')
            gpError = true;
        }
    })

    if (gpError) $('.js-gp-message').show();
}
